<template>
  <div style=" width: 100%; color: white; display: flex; flex-direction: column">
    <div id="header">各区设备占比</div>
    <div id="leftTwo2Top"></div>
    <div v-if="!isLoading" id="leftTwo2Bottom" style="width:510px;height: 300px;overflow-x: scroll">
      <table align='center' style="width: 300px">
        <tr>
          <th></th>
          <!--<th v-for="item in areas">{{getAreaNameCN(item)}}</th>-->
          <th v-for="item in areaNames" nowrap="nowrap" style="border-right: 1px solid rgba(255,255,255, 0.5)">{{item}}</th>
        </tr>
        <tr>
          <td style="width:100px;white-space: nowrap;">设备总数</td>
          <td v-for="item in devNum">{{item.devNum}}</td>
        </tr>
        <tr>
          <td >设备供电</td>
          <td v-for="item in CENum">{{item.CENum}}</td>
        </tr>
        <tr>
          <td >设备开机</td>
          <td v-for="item in onNum">{{item.onNum}}</td>
        </tr>
        <tr>
          <td >监测在线</td>
          <td v-for="item in onlineNum">{{item.onlineNum}}</td>
        </tr>
        <tr>
          <td >监测分贝</td>
          <td v-for="item in alarmNum">{{item.alarmNum}}</td>
        </tr>

      </table>

    </div>
    <div v-else></div>
  </div>
</template>

<script>
import echarts from 'echarts'
// import * from '../../../assets/js/echarts-auto-tooltip'
import loopShowTooltip1 from '../../../assets/js/cycleHightLight1'
export default {
  name: 'HomeLeftTwo2',
  data(){
    return {
      isLoading: true,
      // 获取区域列表
      GetAreaList:{
        "version": 1,
        "method": "area.GetAreaList",
        "params": null
        ,
        "token": "",
        "id": 0
      },
      AreaDevScreen:{
        "version": 1,
        "method": "synthScreen.AreaDevScreen",
        "params": {
          "areaId":"0",
        },
        "token": "",
        "id": 0
      },
      chart:"",
      areaArray: [],
      areas:[
        // {
        //   areaId:'',
        //   areaName:'',
        //   devNum:'',
        // }
      ], // 区域id
      areaNames:[], // 区域名称
      types: ['设备总数', '在线数', '市电供电', '开机数', '告警数'],
      option:{
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ['#1ca9e9','#db1ce9','#0154c8','#26c1c9','#6658cb'],
        series: [
          {
            name:'设备总数',
            type:'pie',
            radius: ['60%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center',
                fontSize: 12,
                fontWeight: 'bold',
                formatter: '{b}\n\n{d}%'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '18',
                  fontWeight: 'bold',
                  color: 'white'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data:[]
          }
        ]
      },
      interval:'', // 轮询
      index: 0,

      CENum:[], // 市电供电数
      alarmNum:[], // 告警数
      devNum:[], // 设备总数
      onNum:[], // 开机数
      onlineNum:[], //在线数

      formerCENum:[], // 市电供电数
      formeralarmNum:[], // 告警数
      formerdevNum:[], // 设备总数
      formeronNum:[], // 开机数
      formeronlineNum:[], //在线数

      chartInterval:null, // 表格高亮循环
      chartIndex:0, // 高亮索引
    }
  },
  methods:{
    // 判断两个数组相等
    arraySame(arr1 ,arr2){
      return arr1.toString() === arr2.toString();
    },
    getAreaNameCN(areaId){
      let res = "";
      this.areaArray.forEach(item=>{
        if(item.areaId === areaId){
          res = item.areaName;
        }
      })
      return res;
    },
    getAreaDevScreen(init){
      clearInterval(this.chartInterval); // 请求之前，先把自动循环高亮消除
      // init为真，则是第一次请求，要有显示和隐藏的切换，其他情况下不需要
      if(init){
        this.isLoading = true;
      }
      this.AreaDevScreen.token = this.$store.state.token;
      console.log('获取各区设备情况');
      console.log(this.AreaDevScreen);
      this.$axios.post(this.$newMainUrl, this.AreaDevScreen).then(res=> {

        // 保存上一次数组的情况
        this.formeronNum = JSON.parse(JSON.stringify(this.onNum));
        this.formeronlineNum = JSON.parse(JSON.stringify(this.onlineNum));
        this.formerdevNum = JSON.parse(JSON.stringify(this.devNum));
        this.formeralarmNum = JSON.parse(JSON.stringify(this.alarmNum));
        this.formerCENum = JSON.parse(JSON.stringify(this.CENum));

        this.isLoading = false;
        console.log('获取各区设备情况请求得到响应');
        console.log(res.data);
        // 让数值与列所表示的区对应，所以要规定顺序
        if(res.data.hasOwnProperty('result')){
          let optionData = [];
          this.areas = [];
          this.areaNames = [];

          for(let i = 0; i<res.data.result.CENum.length;i++){
            if(res.data.result.CENum[i].hasOwnProperty('areaId')){
              this.areas.push(res.data.result.CENum[i].areaId);
              this.areaNames.push(res.data.result.CENum[i].areaName);
            }
          }
          // res.data.result.CENum.forEach(item =>{
          //
          // })
          this.CENum = [];
          this.areas.forEach(item =>{
            res.data.result.CENum.forEach(item2 =>{
              if(item === item2.areaId){
                this.CENum.push(item2);
              }
            })
          })
          this.alarmNum = [];
          this.areas.forEach(item =>{
            res.data.result.alarmNum.forEach(item2 =>{
              if(item === item2.areaId){
                this.alarmNum.push(item2);
              }
            })
          })
          this.devNum = [];
          this.areas.forEach(item =>{
            res.data.result.devNum.forEach(item2 =>{
              if(item === item2.areaId){
                this.devNum.push(item2);
              }
            })
          })
          this.onlineNum = [];
          this.areas.forEach(item =>{
            res.data.result.onlineNum.forEach(item2 =>{
              if(item === item2.areaId){
                this.onlineNum.push(item2);
              }
            })
          })
          this.onNum = [];
          this.areas.forEach(item =>{
            res.data.result.onNum.forEach(item2 =>{
              if(item === item2.areaId){
                this.onNum.push(item2);
              }
            })
          })


          // 如果与上一次不同才重绘，否则不做改变
          if(this.arraySame(this.CENum, this.formerCENum) && this.arraySame(this.alarmNum, this.formeralarmNum) && this.arraySame(this.devNum, this.formerdevNum)
            && this.arraySame(this.onlineNum, this.formeronlineNum) && this.arraySame(this.onNum, this.formeronNum)){

          }else{
            let t = JSON.stringify(this.devNum);
            t = t.replace(/areaId/g, "name");
            t = t.replace(/devNum/g, "value");
            t = JSON.parse(t);
            t.map(item =>{
              // item.name = this.getAreaNameCN(item.name);
              item.name = item.areaName;
            })
            // 过滤掉值为0 的 区域，否则饼图会出现这些区域的跳动，但不会有任何效果
            this.option.series[0].data =  t.filter(item =>{
              return item.value > 0;
            });
            this.drawChart(this.chart, "leftTwo2Top", this.option);
          }


        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    },
    drawChart(chart, id, option){
      // 绘制表格
      console.log('绘制饼图');
      chart = echarts.init(document.getElementById(id))
      chart.setOption(option);
      loopShowTooltip1(chart, option, {loopSeries: true});  // 让屏幕动起来


      // 开启默认高亮
      // let index = 0; // 高亮索引
      // chart.dispatchAction({
      //   type: "highlight",
      //   seriesIndex: index,
      //   dataIndex: index
      // });
      // chart.on("mouseover", function(e) {

        // clearInterval(this.interval); // 悬浮的时候就不继续周期跳动了，否则会出现两个同时高亮的现象

        // if (e.dataIndex !== index) {
        //   chart.dispatchAction({
        //     type: "downplay",
        //     seriesIndex: 0,
        //     dataIndex: index
        //   });
        // }
      // });
      // chart.on("mouseout", function(e) {

        // 光标移走，继续轮询
        // this.interval = setInterval(()=>{
        //   this.getAreaDevScreen();
        // }, 3000)
        //
        // index = e.dataIndex;
        // chart.dispatchAction({
        //   type: "highlight",
        //   seriesIndex: 0,
        //   dataIndex: e.dataIndex
        // });
      // })
    },

    getItem(i){
      return 'item' + " " + "item" + i;
    },
    hasClass(element, cls){
      return (element.className+"").indexOf(cls) > -1;
    },
    getNumber(element){
      // console.log(element.className);
      // console.log(parseInt((element.className+"").replace(/[^\d.]/g, "")));
      return parseInt((element.className+"").replace(/[^\d.]/g, ""));
    },
    // 获取区域列表
    getAreaList(){
      this.GetAreaList.token = this.$store.state.token;
      console.log('获取区域列表请求');
      console.log(this.GetAreaList);
      this.$axios.post(this.$newMainUrl, this.GetAreaList).then(res=>{
        console.log('获取区域列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.areaArray = [];
          res.data.result.areaList.forEach(item =>{
            let t = {};
            t.areaName = item.areaName;
            t.areaId = item.areaId;
            this.areaArray.push(t);
            item.childList.forEach(item2 =>{
              let tt = {};
              tt.areaName = item2.areaName;
              tt.areaId = item2.areaId;
              this.areaArray.push(tt);
            })
            // resolve();
          })
        }else{
          this.$message({
            type: 'error',
            message: '获取区域列表失败，' + res.data.error.message
          })
        }
      })
    },
  },
  mounted (){
    // new Promise(resolve => {
      this.getAreaList();
    // }).then(()=>{
      this.getAreaDevScreen();
      this.interval = setInterval(()=>{
        this.getAreaDevScreen();
      }, 3000)
    // })
  },
  destroyed () {
    this.getAreaDevScreen(true);
    // clearInterval(this.interval);
    clearInterval(this.chartInterval); // 停止饼图的循环高亮
    clearInterval(this.interval); // 停止轮询
  }
}
</script>

<style scoped lang="scss">
  $numOfAreas: 6;
  $numOfTypes: 5;

  #header{
    color: white;
    font-size: 18px;
    font-family: 黑体;
    font-weight: bold;
    margin-left: 30px;
    margin-top: 10px;
  }
  circle{
    -webkit-transition: stroke-dasharray .25s;
    transition: stroke-dasharray .25s;
  }
  #leftTwo2Top{
    text-align: center;
    position: relative;
    width: 100%;
    height: 160px;
  }
  #leftTwo2Bottom{
    margin-top: -10px;
    margin-left: -30px;
    font-size: 20px;
    font-family: 黑体;
    transform: scale(0.8);

    width: 110%;
    height: 160px;
    table{
      /*white-space: nowrap;*/
      width:120%;
      height: 100%;
      text-align: center;
      border-collapse: collapse;
      tr{
        background-color: #26374c;
        height: 36px;
      }
      tr:first-of-type{
        font-size: 20px;
        transform: scale(1);
        background-color: #20337e;
        th{

        }
      }
    }

  }
  svg{
    circle{
      transform: translate(50%, 50%);
    }
  }
</style>
